const getEnvironmentUrl = (
  defaultUrl: string,
  urlMap: {
    local?: string;
    qa?: string;
    dev?: string;
    stage?: string;
    prod?: string;
  },
) => {
  const origin = globalThis.location.origin;

  if (origin === process.env.REACT_APP_URL) {
    return urlMap.local || defaultUrl;
  }

  if (origin === process.env.REACT_APP_URL_QA) {
    return urlMap.qa || defaultUrl;
  }

  if (origin === process.env.REACT_APP_URL_DEV) {
    return urlMap.dev || defaultUrl;
  }

  if (origin === process.env.REACT_APP_URL_STAGE) {
    return urlMap.stage || defaultUrl;
  }

  if (origin === process.env.REACT_APP_URL_PROD) {
    return urlMap.prod || defaultUrl;
  }

  return defaultUrl;
};

export const baseURL = getEnvironmentUrl(
  process.env.REACT_APP_BASEURL_PROD || "",
  {
    local: process.env.REACT_APP_BASEURL || "",
    qa: process.env.REACT_APP_BASEURL_QA || "",
    dev: process.env.REACT_APP_BASEURL_DEV || "",
    stage: process.env.REACT_APP_BASEURL_STAGE || "",
    prod: process.env.REACT_APP_BASEURL_PROD || "",
  },
);
export const env = process.env.NODE_ENV;
export const serverAddress = new URL(baseURL);
export const oauthServerAddress = new URL(
  getEnvironmentUrl(process.env.REACT_APP_OAUTH_BASEURL_PROD || "", {
    local: process.env.REACT_APP_OAUTH_BASEURL || "",
    qa: process.env.REACT_APP_OAUTH_BASEURL_QA || "",
    dev: process.env.REACT_APP_OAUTH_BASEURL_DEV || "",
    stage: process.env.REACT_APP_OAUTH_BASEURL_STAGE || "",
    prod: process.env.REACT_APP_OAUTH_BASEURL_PROD || "",
  }),
);
export const authority = process.env.REACT_APP_AUTHORITY;
export const clientId = process.env.REACT_APP_CLIENTID;
export const authorityProd = process.env.REACT_APP_AUTHORITY_PROD;
export const clientIdProd = process.env.REACT_APP_CLIENTID_PROD;
export const redirectUri = process.env.REACT_APP_REDIRECTURI;
